import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  userRole: string = localStorage.getItem("role");
  user_menu: any[];
  constructor(private router: Router,private toastr: ToastrService, private apiService: ApiService) { }

  ngOnInit() {
    this.getProfile();
    setTimeout(() => this.setSideBar(),1000); 

  }
  setSideBar(){
    if(this.userRole == 'procurement')
    {
      this.user_menu =[
        {name: 'My Team',key: 'myTeamCount',keyCount: localStorage.getItem("team_count"),url: '/procurement/team', isActive: false ,dataKey: "my_team"},
        {name: 'Daily Checks',key: 'dailyChecks',keyCount: localStorage.getItem("daily_checks_count"),url: '/procurement/dailychecks', isActive: false,dataKey: "daily_checks"},
        {name: 'History',key: 'history',keyCount: 0,url: '/procurement/history', isActive: false,dataKey: "history"},
        {name: 'Impact',key: 'impacts',keyCount: localStorage.getItem("impacts_count"),url: '/procurement/impacts', isActive: false,dataKey: "impacts"},
        {name: 'Deals',key: 'deals',keyCount: localStorage.getItem("deals_count"),url: '/procurement/deal', isActive: false,dataKey: "deals"},
        {name: 'Bonus Bounties',key: 'bonusBounties',keyCount: localStorage.getItem("bounties_count"),url: '/procurement/bounty', isActive: false,dataKey: "bonus_bounties"},
        {name: 'Settings',key: 'settings',keyCount: 0,url: '/procurement/settings', isActive: false},

      ];
    }
    else if(this.userRole == 'team_member')
    {
      this.user_menu =[
        {name: 'My Team',key: 'myTeamCount',keyCount: localStorage.getItem("team_count"),url: '/procurement/team' , isActive: false, dataKey:"my_team"},
        {name: 'Play',key: 'play',keyCount: 0,url: '/procurement/menu', isActive: false},
        {name: 'My Reviews',key: 'myReviews',keyCount: localStorage.getItem("reviews_count"),url: '/procurement/reviews', isActive: false,dataKey: "my_reviews"},
        {name: 'Impact',key: 'impacts',keyCount: localStorage.getItem("impacts_count"),url: '/procurement/impacts', isActive: false,dataKey: "impacts"},
        {name: 'Bonus Bounties',key: 'bonusBounties',keyCount: localStorage.getItem("bounties_count"),url: '/procurement/bounty', isActive: false,dataKey: "bonus_bounties"},
        {name: 'Settings',key: 'settings',keyCount: 0,url: '/procurement/settings', isActive: false},
      ];
    }

    const objIndex = this.user_menu.findIndex((obj => obj.url == this.router.url));
    this.user_menu[objIndex].isActive = true;
  }
  
  redirectUrl(key)
  {
  
    const objIndexActive = this.user_menu.findIndex((obj => obj.isActive == true));
    if(objIndexActive >= 0)
    {
      this.user_menu[objIndexActive].isActive = false;
    }
    const objIndex = this.user_menu.findIndex((obj => obj.key == key));
    this.user_menu[objIndex].isActive = true;
    if(this.user_menu[objIndex].keyCount >0)
    {
      this.apiService.clearData(this.user_menu[objIndex].dataKey)
        .subscribe((res: any) => {
            if(res.status === 'Success') {
              this.user_menu[objIndex].keyCount = 0;
            }
        });
      }
      /*if(key=='dailyChecks'){
        localStorage.setItem('daily_checks_count','0');
      }*/
      this.getProfile();
      this.router.navigateByUrl (this.user_menu[objIndex].url);
    
  }

  getProfile()
  {
      this.apiService.getUserProfile()
      .subscribe((res: any) => {
          if(res.status === 'Success') {
            localStorage.setItem('user_company',res.data.companyName);
            localStorage.setItem('user_score',res.data.rewards);
            localStorage.setItem('user_left_attempts',res.data.leftAttempts);
            localStorage.setItem('daily_checks_count',res.data.dailyChecks);
            localStorage.setItem('team_count',res.data.myTeamCount);
            localStorage.setItem('reviews_count',res.data.myReviewsCount);
            localStorage.setItem('bounties_count',res.data.bonusBounties);
            localStorage.setItem('deals_count',res.data.deals);
            localStorage.setItem('impacts_count',res.data.impacts);
            localStorage.setItem('team_rank',res.data.teamRank);
          }
      });
  }

}
